import './Rewards.css';

const Rewards = () => {
    return (
        <div className="rewards-page">
            <div className="rewards-container">
                <h1>Rewards Program</h1>
                <p>Join our rewards program and earn points with every purchase!</p>
                {/* Add more content as needed */}
            </div>
        </div>
    );
};

export default Rewards;